var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFolderCheck = function SvgFolderCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_237_5439",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_237_5439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.12508 13.3492L13.0578 9.4165L12.2917 8.65046L9.12508 11.8092L7.70842 10.4213L6.94237 11.1873L9.12508 13.3492ZM3.75654 15.5832C3.39112 15.5832 3.07647 15.4512 2.81258 15.1873C2.54869 14.9234 2.41675 14.6088 2.41675 14.2434V5.7563C2.41675 5.38116 2.54869 5.06407 2.81258 4.80505C3.07647 4.54602 3.39112 4.4165 3.75654 4.4165H7.83175L9.83175 6.4165H16.2436C16.6188 6.4165 16.9358 6.54602 17.1949 6.80505C17.4539 7.06407 17.5834 7.38116 17.5834 7.7563V14.2434C17.5834 14.6088 17.4539 14.9234 17.1949 15.1873C16.9358 15.4512 16.6188 15.5832 16.2436 15.5832H3.75654ZM3.75654 14.4998H16.2436C16.3185 14.4998 16.3799 14.4758 16.428 14.4278C16.4761 14.3797 16.5001 14.3182 16.5001 14.2434V7.7563C16.5001 7.68143 16.4761 7.61998 16.428 7.57192C16.3799 7.52387 16.3185 7.49984 16.2436 7.49984H9.383L7.383 5.49984H3.75654C3.68168 5.49984 3.62022 5.52387 3.57216 5.57192C3.52411 5.61998 3.50008 5.68143 3.50008 5.7563V14.2434C3.50008 14.3182 3.52411 14.3797 3.57216 14.4278C3.62022 14.4758 3.68168 14.4998 3.75654 14.4998Z",
    fill: "#1C1B1F"
  }))));
};
export default SvgFolderCheck;